import React from 'react';

const NotFound: React.FC = () => {
return (
    <div className="starry-bg min-h-screen flex items-center justify-center bg-gray-900 p-4">
        <div className="text-center bg-gray-800 p-8 rounded-lg shadow-xl border border-red-500/30 max-w-lg w-full">
            <div className="mb-6">
            <svg
                className="mx-auto h-24 w-24 text-red-500 animate-pulse"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
            </svg>
            </div>
            <h1 className="text-3xl font-bold text-red-500 mb-4">Akses Terbatas!</h1>
            <p className="text-gray-300 text-lg mb-6">
            Halaman ini merupakan bagian dari dokumen rahasia negara dan tidak dapat diakses oleh publik.
            </p>
            <div className="text-sm text-gray-400 border-t border-gray-700 pt-4">
            Kode Keamanan: TOP-SECRET-7X9Y2
            </div>
        </div>
    </div>
);
};

export default NotFound;